export abstract class BaseTrackingService {
  protected getCookie(name: string): string {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  abstract addHeaders(headers: Record<string, string>): Record<string, string>;
}
